//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

export class NoInstagramBusinessConnectedTooltip {
  public brandMentionedInCaption: boolean;
  public instagramBusinessId: string;
}

angular.module('curalate').component('noInstagramBusinessConnectedTooltip', {
  bindings: {
    brandMentionedInCaption: '<',
    instagramBusinessId: '<',
  },
  controller: [
    'SessionVarsService',
    NoInstagramBusinessConnectedTooltip,
  ],
  transclude: true,
  template: `
        <cu-tooltip ng-if="$ctrl.brandMentionedInCaption && !$ctrl.instagramBusinessId"
                    class="cu-d-flex cu-flex-column cu-justify-content-center pull-right no-business-connected-tooltip"
                    style="height: 65px;">
            <cu-tooltip-target style="color: #e64c51; cursor: pointer;">
                <span style="font-size: 13px;">Action Required</span>
                <cu-icon name="alarm"></cu-icon>
            </cu-tooltip-target>
            <cu-tooltip-content class="cu-d-block cu-m-3">
                <ng-transclude></ng-transclude>
            </cu-tooltip-content>
        </cu-tooltip>
    `,
});
